export type DeviceConfiguration = {
  deviceFamilyId: number;
  ebox?: {
    app: {
      appStoreUrl: string | undefined;
      id: string | undefined;
      host: string | undefined;
      playStoreUrl: string | undefined;
      schema: string | undefined;
      tizenAppId: string | undefined;
      tizenStoreAppId: string | undefined;
      webOsAppId: string | undefined;
    };
    isMigrationEnabled: boolean;
    isServerTerminated: boolean;
    qrCodeUrl: string | undefined;
    restrictedMenuReference: string | undefined;
    subscriptions: Set<string>;
    sunsetAssetId: string | undefined;
  };
  forceUpgradeLinks?: Record<string, string>;
  forceUpgrade?: {
    enabled: boolean;
    languageCode?: string;
    skippableInterval: number;
    brands: {
      blocked: Set<number>;
      forced: Set<number>;
      skippable: Set<number>;
    };
  };
  personalLists?: {
    chosenSearch: number | undefined;
    personal: number | undefined;
    savedInterestItems: number | undefined;
    userPersonalLineup: number | undefined;
  };
  translationDictionaries: Record<string, string>;
};

export enum ForceUpgradeType {
  Blocked = 'blocked',
  Forced = 'forced',
  Skippable = 'skippable',
}

export type BlockedUpgrade = {
  type: ForceUpgradeType.Blocked;
};

export type ForcedUpgrade = {
  links?: Record<string, string>;
  type: ForceUpgradeType.Forced;
};

export type SkippableUpgrade = {
  links?: Record<string, string>;
  skippableInterval: number;
  type: ForceUpgradeType.Skippable;
};

export type ForceUpgradeConfiguration = BlockedUpgrade | ForcedUpgrade | SkippableUpgrade;
